import clsx from 'clsx'
import useTranslation from 'next-translate/useTranslation'
import { memo } from 'react'

import DiscountPrice from '@/atoms/DiscountPrice'
import FansiMark from '@/atoms/FansiMark'
import formatProductPrice from '@/helpers/formatProductPrice'
import getProductPrice from '@/helpers/getProductPrice'
import { FansiKind } from '@/ts/Global'
import Product from '@/ts/Product'

function Header(props: HeaderProps) {
  const { t } = useTranslation('global')
  const { product, kind } = props

  const price = getProductPrice(props.product)
  const priceLabel = formatProductPrice(product)

  if (kind === 'fansi_video') {
    return (
      <div className="flex flex-col items-center">
        {price.price_before_discount < price.value ? (
          <span className="text-4xl text-medium">{priceLabel}</span>
        ) : (
          <>
            <DiscountPrice
              priceBeforeDiscount={price.price_before_discount}
              price={price.value}
              className="text-lg"
            />
            <span
              className={clsx(
                'text-4xl',
                price.price_before_discount > price.value
                  ? 'font-bold text-red-300'
                  : 'font-medium'
              )}
            >
              {priceLabel}
            </span>
          </>
        )}
      </div>
    )
  }
  return (
    <div>
      <h1 className="mb-4 text-2xl font-medium break-words">{product.name}</h1>
      <div className="flex items-center mb-8 space-x-4">
        <span className="text-black/60">{t(kind)}</span>
        <FansiMark kind={kind} />
      </div>
      <div className="flex flex-col">
        {price.price_before_discount < price.value ? (
          <span className="text-4xl text-medium">{priceLabel}</span>
        ) : (
          <>
            <DiscountPrice
              priceBeforeDiscount={price.price_before_discount}
              price={price.value}
              className="text-lg"
            />
            <span
              className={clsx(
                'text-4xl',
                price.price_before_discount > price.value
                  ? 'font-bold text-red-300'
                  : 'font-medium'
              )}
            >
              {priceLabel}
            </span>
          </>
        )}
      </div>
    </div>
  )
}

interface HeaderProps {
  kind: FansiKind
  product: Product
}

export default memo(Header)
